<template>
    <tr>
        <td>
            <div class="transaction__type " :class="getPaymentClass"></div>
        </td>
        <td>{{ transaction.id }}</td>
        <td>{{ getTransactionName }}</td>
        <td>{{ transaction.date }}</td>
        <td><strong class="color__red" :class="getAmountClass" v-html="getPrice"></strong></td>
    </tr>
</template>

<script>
export default {
    name: "TransactionItem",
    props: {
        transaction: {
            type: [Object, Array]
        },
        currencies: {
            type: [Object, Array]
        },
        paymentoperations: {
            type: [Object, Array]
        },
        paymentmethods: {
            type: [Object, Array]
        },
        transactionsTypes: {
            type: [Object, Array]
        },
    },
    data() {
        return {}
    },
    computed: {
        getTransactionName() {
            return this.transactionsTypes.filter((item) => {
                return item['id'] === this.transaction['type_id']
            })[0]['title'] ?? '';
        },
        getPaymentClass() {
            return this.transactionsTypes.filter((item) => {
                return item['id'] === this.transaction['type_id']
            })[0]['class'] ?? '';
        },
        getAmountClass() {
            return this.paymentoperations['Extract'] === this.transaction['payment_operation_type_id'] ? 'color__red' : 'color__green'
        },
        getPrice() {
            return this.transaction['amount'] + this.currencies.filter((item) => {
                return item['id'] === this.transaction['currency_id']
            })[0]['symbol'] ?? '';

        }
    }
}
</script>

<style scoped>

</style>
